import React from 'react'
// @ts-ignore
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'

import './lang/i18n'
import store from './store'
import './index.scss'
import App from './ui/app'
import { fetchHistory } from './ui/history/reducer'
import { authLogin } from './ui/user/auth/reducer'

async function main() {

	
	store.dispatch(authLogin())
	store.dispatch(fetchHistory())
	let portalGenerated: any;
const checker = () => {
    try {
        
        console.log("portal generated check", window.game.scene.scenes[0].load.queue.entries.length);
    } catch (error) {
        
    }

  if (!window.dataPos) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.dataPos["portrait"]) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.dataPos["portrait"]["master"]) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.dataPos["portrait"]["master"].col) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.portals) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.portals["portrait"]) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.portals["portrait"]["master"]) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  if (!window.portals["portrait"]["master"].length) {
    portalGenerated = setTimeout(checker, 500);
    return;
  }
  
  if ( window.portals["portrait"]["master"].length === window.dataPos["portrait"]["master"].col * 9 && !window.game.scene.scenes[0].load.queue.entries.length) {
	ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
		<React.StrictMode>
			<Provider store={store}>
				<App />
			</Provider>
		</React.StrictMode>
	)
    clearTimeout(portalGenerated);
    return;
  }
};

portalGenerated = setTimeout(checker, 500);
	
}

main()
